<template>
    <div class="send-email-body">
        <div class="send-email-title">
            無料体験<span>から</span>契約<span>までの</span>流れ
        </div>
        <div class="process-body">
            <div class="process"
                v-for="(n, index) in processList"
                :key="index"
                >
                <div class="name-area" :style="`border-color:${n.color}`">
                    <div class="name-inset" :style="`background:${n.color};${n.nameLines > 1 ? '' : 'padding-top:18px'}`" v-html="n.name"></div>
                </div>
                <div class="msg-area" :style="`${n.nameLiness == 2 ? 'top:20px' : ''}`" v-html="n.msg"></div>
                <div class="down-icon" v-if="index !== processList.length - 1">
                    <img :src="down" />
                </div>
            </div>
            <div class="h-40"></div>
            
        </div>
        <div class="send-body">
            <div class="send-title">申込書</div>
            <div class="form-area">
                <div class="input-name">
                    氏名<label>必須</label>
                </div>
                <div class="input-area">
                    <a-input v-model:value="name" size="large" placeholder="例:山田太郎" />
                </div>
            </div>
            <div class="form-area">
                <div class="input-name">
                    国/地域<label>必須</label>
                </div>
                <div class="input-area">
                    <div class="address-all">
                        {{ allAddress }}
                    </div>
                    <a-select style="width: 100%" size="large" v-model:value="allAddress" @focus="visible = true">
                        <a-select-option :value="n" v-for="n in allAddressList" :key="n">
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="form-area">
                <div class="input-name">
                    メール<label>必須</label>
                </div>
                <div class="input-area">
                    <a-input v-model:value="email" size="large" placeholder="例:@.Tocom.net" />
                </div>
            </div>
            <div class="form-area">
                <div class="input-name">
                    性別<label>必須</label>
                </div>
                <div class="input-area">
                    <div class="radio-body">
                        <a-radio-group name="radioGroup" v-model:value="sex">
                            <a-radio :value="0">
                            男
                            </a-radio>
                            <a-radio :value="1">
                            女
                            </a-radio>
                        </a-radio-group>
                    </div>
                </div>
            </div>
            <div class="form-area">
                <div class="input-name">
                    ご利用端末を選択してください<label>必須</label>
                </div>
                <div class="input-area">
                    <div class="checkbox-outer" v-for="(n, index) in checkboxDataList" :key="index">
                        <a-checkbox @change="setTerminal(index)" v-model:value="businesskeys">
                            {{ n.name }}
                        </a-checkbox>
                        <div class="checkbox-msg-area">
                            <div v-for="(c, ind) in n.forList" :key="ind">
                                {{ c }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-msg">
                Firitvstickなどテレビ向けアプリのダウンロード方法は<br/>
                申込後にメールにて返送します。
            </div>
            <div class="form-area">
                <div class="input-name">
                    質問事項など
                </div>
                 <div class="input-area">
                     <a-textarea
                        v-model:value="question"
                        placeholder="ご相談内容・資料請求など、お客さまのご希望内容をご入カください"
                        :auto-size="{ minRows: 3 }"
                        />
                </div>
            </div>
            <div class="send-btn" @click="send()">送信</div>
            <a-drawer
                :title="chooseIndex === 0 ? '国家選択' : '都市選択'"
                height="500"
                placement="bottom"
                :closable="false"
                :visible="visible"
                @close="onClose"
            >
                <!-- <div class="list-outer"> -->
                    <div class="country-or-city" v-if="chooseIndex === 0">
                        <div class="list" v-for="n in diclist" :key="n.id" @click="setCountry(n.val)">
                            {{ n.val }}
                        </div>
                    </div>
                    <div class="country-or-city" v-if="chooseIndex === 1" >
                        <div class="list" v-for="n in cityList" :key="n.id" @click="setCity(n.val)">
                            {{ n.val }}
                        </div>
                    </div>
                <!-- </div> -->
            </a-drawer>
        </div>
        <send-success v-model:isShow.sync="sendSuccessShow"></send-success>
    </div>
</template>
<script>
import { down } from './images'
import sendSuccess from './modules/send-success'
export default {
    components: {
        sendSuccess
    },
    computed: {
    },
    watch: {
        city (n) {
            if (n) {
                this.allAddressList = []
                this.allAddress = `${ this.country } / ${ this.city }`
                this.allAddressList.push(`${ this.country } / ${ this.city }`)
            } else {
                this.allAddress = null
            }
        },
    },
    data () {
        return {
            name: null,
            down,
            country: null,
            email: null,
            sex: null,
            terminal: null,
            question: null,
            sendSuccessShow: false,
            isSending: false,
            diclist: [],
            allAddress: null,
            visible: false,
            chooseIndex: 0,
            cityList: [],
            city: null,
            agentcode: 107,
            businesskeys: new Set(),
            processList: [
                {
                    name: 'お申込',
                    color: '#EC424B',
                    nameLines: 1,
                    nameLiness: 2,
                    msg: '申込書、メールにて一週間無料体験を<br/>お申込みいただきます。'
                },
                {
                    name: 'ID<br/>発行',
                    color: '#42C2EC',
                    nameLines: 2,
                    nameLiness: 2,
                    msg: 'メールにて対応端末の無料体験IDと<br/>パスワードを発行します。'
                },
                {
                    name: 'アプリ<br/>設定',
                    color: '#95DD75',
                    nameLines: 2,
                    nameLiness: 2,
                    msg: '対応端末アプリをダウンロードして、<br/>発行IDとパスワードでログインします。'
                },
                {
                    name: '無料<br/>体験',
                    color: '#FDB819',
                    nameLines: 2,
                    nameLiness: 1,
                    msg: 'スマホ、タブレット、スマートTV端末でKaiteki TVすべての機能を一週間無料体験していただけます。'
                },
                {
                    name: 'ご契約',
                    color: '#F06CE2',
                    nameLines: 1,
                    nameLiness: 1,
                    msg: 'ご利用の端末からの購入画面に進んで<br/>頂き、クレジットカードにてお支払となります。お支払後すぐにご利用が可能となります。'
                },
            ],
            allAddressList: [],
            checkboxDataList: [
                {
                    id: 1,
                    name: 'モバイル端末向けアプリで視聴',
                    forList: [
                        'iPhone/iPad ',
                        'Amazon Fire HD',
                        'Android Phone/Pad'
                    ]
                },
                {
                    id: 2,
                    name: 'テレビ端末向けアプリで視聴',
                    forList: [
                        'FireTV Stick',
                        'Chromecast with Google TV',
                        'Google Play対応SmartTV / SmartTV BOX'
                    ]
                }
            ]
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.name = null
            this.country = null
            this.email = null
            this.sex = null
            this.terminal = null
            this.question = null
            this.getCountryList()
        },
        send () {
            if (this.isSending) {
                return false
            }
            if (!this.name || !this.email || !this.city || (!this.sex && this.sex !== 0) || Array.from(this.businesskeys).length === 0) {
                console.log('缺失数据')
                console.log({
                    name: this.name,
                    email: this.email,
                    city: this.city,
                    sex: this.sex,
                    keys: Array.from(this.businesskeys)
                })
                return false
            }
            this.isSending = true
            let businesskeys = []
            Array.from(this.businesskeys).forEach(n => {
                businesskeys.push(n === 0 ? 'phoneTV' : 'EuropeTV')
            })
            this.$http({
                url: "https://mpay.kaitekitv.com/visitor/user/user/boxWebRegister",
                method: "post",
                params: this.$http.adornParams({
                    name: this.name,
                    email: this.email,
                    businesskey: businesskeys[0],
                    country: this.country,
                    city: this.city,
                    remark: this.question,
                    sex: this.sex,
                    flag: 1,
                    agentcode: this.agentcode
                }),
            }).then(({data}) => {
                console.log(data);
                // this.isSending = false
                if (data.code === 0) {
                    if(businesskeys[1] == 'EuropeTV' || businesskeys[1] == 'phoneTV'){
                        this.$http({
                            url: "https://mpay.kaitekitv.com/visitor/user/user/boxWebRegister",
                            method: "post",
                            params: this.$http.adornParams({
                                name: this.name,
                                email: this.email,
                                businesskey: businesskeys[1],
                                country: this.country,
                                city: this.city,
                                remark: this.question,
                                sex: this.sex,
                                flag: 1,
                                agentcode: this.agentcode
                            }),
                        }).then(({data}) => {
                            console.log(data);
                            this.isSending = false
                            if (data.code === 0) {
                                this.sendSuccessShow = true
                            }else{
                                alert(data.msg)
                                this.$message.error(data.msg)
                            }
                        })
                    }
                    this.diclist = data.diclist
                    this.sendSuccessShow = true
                } else {
                    alert(data.msg)
                    this.$message.error(data.msg)
                }
            });
        },
        setTerminal (index) {
            if (this.businesskeys.has(index)) {
                this.businesskeys.delete(index)
            } else {
                this.businesskeys.add(index)
            }
            console.log(this.businesskeys)
            console.log(index)
        },
        setCountry (val) {
            this.country = val
            this.chooseIndex = 1
            this.getCityList()
        },
        setCity (val) {
            this.city = val
            this.chooseIndex = 2
            this.onClose()
        },
        getCountryList () {
            
            this.$http({
                url: "https://mpay.kaitekitv.com/visitor/user/dic/getlistByType",
                method: "get",
                params: this.$http.adornParams({
                    type:"country"
                }),
            }).then(({ data }) => {
                console.log(data);
                if (data.code === 0) {
                    this.diclist = data.diclist
                } else {
                    this.$message.error(data.msg)
                }
            });
        },
        getCityList () {
            this.cityList = []
            this.$http({
                url: "https://mpay.kaitekitv.com/visitor/user/dic/getlistByParentId",
                method: "get",
                params: this.$http.adornParams({
                    pid: this.diclist.filter(n => { return n.val === this.country })[0].id
                }),
            }).then(({ data }) => {
                console.log(data);
                if (data.code === 0) {
                    this.cityList = data.diclist
                } else {
                    this.$message.error(data.msg)
                }
            });
        },
        onClose () {
            if (this.chooseIndex === 0) {
                this.country = null
                this.city = null
            } else if (this.chooseIndex === 1) {
                this.country = null
                this.city = null
            }
            this.chooseIndex = 0
            this.visible = false
        }
    }
}
</script>
<style scoped>
.send-email-body {
    width:100%;
    box-sizing: border-box;
    padding: 20px 15px;
    padding-bottom: 60px;
}
.process-body {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    background: #F1F2F4;
    padding-top: 100px;
}
.send-email-title {
    position: absolute;
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    top: 30px;
    left: 0px;
    z-index: 2;
    background: #FDB819;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 70px;
    text-align: center;
}
.send-email-title span {
    font-size: 18px;
}
.process {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
}
.name-area, .msg-area {
    display: inline-block;
    box-sizing: border-box;
}
.name-area {
    text-align: center;
    width: 65px;
    height: 65px;
    box-sizing: border-box;
    padding: 3px;
    border-radius:  50%;
    border:solid 1px #222;
    color:#fff;
    vertical-align: top;
}
.name-inset {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #222;
    box-sizing: border-box;
    line-height: 18px;
    font-size: 13px;
    padding-top: 10px;
}
.msg-area {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    padding-left: 80px;
    left: 0;
    font-size: 14px;
}
.down-icon {
    padding-left: 27px;
    box-sizing: border-box;
    width: 100%;
    margin-top: 10px;
}
.down-icon img {
    display: block;
    width: 10px;
}
.h-40 {
    height: 40px;
}
.send-body {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    padding-top: 60px;
}
.send-title {
    font-size: 24px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: bold;
    text-align: center;
    color: #000000;
    line-height: 30px;
    margin-bottom: 20px;
}
.input-name {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: normal;
    color: #000000;
    margin-bottom: 10px;
}
.input-name label {
    margin-left: 10px;
    padding:  0 5px;
    color: #fff;
    background: #FDB819;
    font-size: 12px;
    height: 15px;
    vertical-align: bottom;
}
.form-area {
    margin-top: 10px;
}
* >>> .ant-input:hover, * >>> .ant-select-focused:not(.ant-select-disabled).ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
    border-color:#FDB819
}
* >>> .ant-input, * >>> .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    outline: #FDB819;
    box-shadow: none;
    border-width: 1px;
    border-color: #DCDADA;
}
* >>> .ant-input::placeholder {
    color: #DCDADA;
}
* >>> .ant-input:focus, * >>> .ant-select-focused:not(.ant-select-disabled).ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    box-shadow: none;
}
.radio-body {
    height: 41.8px;
    box-sizing: border-box;
    padding: 6.5px 11px;
    border:solid 1px #DCDADA;
    border-radius: 2px;
}
.checkbox-outer {
    box-sizing: border-box;
    padding: 6.5px 11px;
    border:solid 1px #DCDADA;
    border-radius: 2px;
    margin-bottom: 10px;
    padding-top: 10px
}
* >>> .ant-radio-inner::after {
    background: #FDB819;
}
* >>> .ant-radio-checked::after {
    border: solid 1px#FDB819
}
* >>> .ant-radio-wrapper:hover .ant-radio,* >>> .ant-radio:hover .ant-radio-inner,* >>> .ant-radio-input:focus + .ant-radio-inner {
    border-color: #FDB819;
}
* >>> ::selection {
    background: #FDB819;
}
* >>> .ant-radio-checked .ant-radio-inner {
    border-color: #FDB819;
}
.send-btn {
    font-size: 18px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: bold;
    color: #020202;
    line-height: 45px;
    text-align: center;
    background: #FDB819;
    border-radius: 3px;
    height: 45px;
    margin-top:27px
}
* >>> .ant-checkbox + span{
    font-weight: bold;
}
.checkbox-msg-area {
    box-sizing: border-box;
    padding-left: 25px;
}
.checkbox-msg-area div {
    margin-right: 20px;
    line-height: 21px;
    font-size: 12px;
    display: inline-block;
}
* >>> ::selection, * >>> .ant-checkbox-checked .ant-checkbox-inner {
    background: #FDB819;
}
* >>> .ant-checkbox-wrapper:hover .ant-checkbox-inner, 
* >>> .ant-checkbox:hover .ant-checkbox-inner, 
* >>> .ant-checkbox-input:focus + .ant-checkbox-inner,
* >>> .ant-checkbox-checked::after {
    border-color: #FDB819;
}
.list-outer {
    
}
.list {
    border-bottom: solid 1px #eee;
    padding: 10px 0;
    font-size: 15px;
}
.list:active {
    color: #FDB819;
}
</style>
<style>
.ant-drawer-body {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 20px !important;
    padding-top:60px !important;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
}
.ant-drawer-header {
    position: relative;
    z-index: 1;
}
.input-area {
    position: relative;
}
.address-all {
    position: absolute;
    z-index: 2;
    top: 9px;
    left: 10px;
}
.form-msg{
    font-size: 11px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    line-height: 18px;
}
</style>
